import React from 'react'
import { archivoCVAPI } from '../../utils/funcionesAPI'
import {manejadorDeRespuesta} from '../../utils/Tools'
import {toast, ToastContainer } from 'react-toastify'
import { RUTA_IMAGEN } from '../../utils/rutasFijas'

const FranquiciaVirtual = (props) => {

  window.scrollTo(0,0);

  function handleEnviarCVClick(e) {
    e.preventDefault();

    const nombre = document.getElementById('nombre');
    const mail = document.getElementById('mail');
    const adjunto = document.getElementById('archivo');

    if (nombre.value === "" || mail.value === "" || adjunto.value === "") {
      toast.error('Debe completar todos los campos', {
        position: toast.POSITION.BOTTOM_CENTER
        });
      return false;
    }

    var form = document.getElementById('formCurriculum');
    var formData = new FormData(form);
    formData.append('accion', 'enviarCurriculumPorMailParaFranquicia');

    toast.info("Enviando...", {
                        position: toast.POSITION.BOTTOM_CENTER
                        });
    archivoCVAPI(formData)
            .then(respuesta => {
              if(manejadorDeRespuesta(props, respuesta))
                toast.success(respuesta.data, {
                                    position: toast.POSITION.BOTTOM_CENTER
                                    });
                document.getElementById("formCurriculum").reset();
            });
  }

  return (
    <section className="sobre-pedraza franquicia">
      <video width="100%" height="400" muted autoPlay loop >
        <source src={`${RUTA_IMAGEN}sobrePedraza/video_trabaja_con_nosotros2.mp4`} type="video/mp4"  />
        Your browser does not support the video tag.
      </video>
    <div className="container">
      {/* <div className="row">
        <article className="txt col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <h1>Sumate al equipo</h1>
          <h6>TE ESTAMOS BUSCANDO PARA SUMARTE AL EQUIPO. MANDANOS TU CURRICULUM!!!</h6>
          <hr />
          <p>Se valorarán aquellas personas con: actitud proactiva y facilidad para establecer relaciones interpersonales.</p>
          <p>Se busca:</p>
          <ul className="listasEnTrabajaConNosotros">
            <li>Vendedores con movilidad propia</li>
            <li>Oficiales de Cuenta</li>
            <li>Personal para Reservas Hoteleras</li>
          </ul>
          <p>Se Ofrece:</p>
          <ul className="listasEnTrabajaConNosotros">
            <li>Relación de dependencia</li>
            <li>Remuneración acorde al desempeño y cumplimiento de objetivos</li>
            <li>Posibilidades de desarrollo</li>
          </ul>
          <p>Los interesados pueden enviar su C.V. a rrhhpedraza@pedraza.com.ar sin omitir referencia del aviso, foto y remuneración pretendida.</p>
        </article>
      </div> */}
      <form id="formCurriculum">
        <p style={{fontSize: 'x-large'}}>SI QUERES OBTENER TU FRANQUICIA VIRTUAL, ENVIANOS TU C.V. A CONTINUACION</p>
        <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label className="labelForm" htmlFor="nombre">Nombre y Apellido</label>
          <input id="nombre" className="form-control" type="text" name="nombre" placeholder="Nombre y Apellido" />
        </div>

        <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label className="labelForm" htmlFor="nombre">Mail</label>
          <input id="mail" className="form-control" type="text" name="puesto" placeholder="Mail" />
        </div>

        <div className="form-group d-inline-block col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
          <label className="labelForm" htmlFor="archivo">Adjuntar CV (.doc, .pdf)</label>
          <input id="archivo" className="form-control" type="file" name="archivo" placeholder="C.V." />
        </div>

        <p className="contenedorLinkInicio col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
          <input className="botonInicio" type="submit" value="Cargar" onClick={handleEnviarCVClick} />
        </p>

      </form>
      <ToastContainer />
    </div>
  </section>
  )
}

export default FranquiciaVirtual



// WEBPACK FOOTER //
// ./src/components/Global/FranquiciaVirtual.js